import React, {useEffect } from 'react';  
import Header from "../Component/Header";
import { Link } from 'react-router-dom'
const InterSchoolCorner = () => {
    useEffect(() => {
        document.title = 'Inter School Corner -  The Air Force School Subroto Park';  
    }, []);  
  return (
     <>
       <Header/>
<div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
              
                 
                 <li> Inter School Corner </li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1> Inter School Corner Competition 2025-2026</h1>
                    </div>
                </div>
                <div className="row">
                <div className="table-responsive maintable">
                <table className="table">
                   <thead>
                          <tr> 
                          <th> Sl No </th> <th> Competition </th> <th> School / Venue </th> <th> Date </th> <th> Last Date of Registration </th> <th> Event </th> <th> Classes </th> <th> No. of Participants </th> <th> Teacher Incharge </th> <th> Remarks </th>
                           </tr>
                    </thead>
                    <tbody> 
                    <tr> <td rowspan="3"> 1 </td> <td rowspan="3">  Goenka Grandeur 2025 </td> <td rowspan="3"> GD Goenka School, Vasant Kunj </td> <td rowspan="3"> 29 Apr-02 May 25 </td> <td rowspan="3"> 18 April 2025 </td> 
                    <td> (a) English Elocution </td><td> 	XI-XII     </td><td> 2 </td><td> 	TSC </td><td></td></tr>
                    <tr><td> (b) Folk Fusion	 </td><td> IX-XII </td><td> 	2	 </td><td> MVJ </td><td></td></tr>
                    <tr><td> (c) Poetry in a frame </td><td> 	IX-XII </td><td> 	2	 </td><td> MVJ </td><td></td></tr>

                     <tr> <td rowspan="11"> 2 </td> <td rowspan="11"> Festival Della Scienza 4.0 </td> <td rowspan="11"> DPS RK Puram  </td> <td rowspan="11"> 26 April 2025 </td> <td rowspan="11"> 18th April 2025 </td>
                     <td> (a) Mappa Mentale  </td><td> 	VI-VIII	 </td><td> 2	 </td><td> PYM </td> <td></td></tr>
                    <tr><td> (b) Fotografia Scientifia	 </td><td> IX-X </td><td> 	2 </td><td> 	ASN </td><td></td></tr>
                    <tr><td> (c) Messagio bobine	 </td><td> XI-XII </td><td> 	2 </td><td> 	SHB </td><td></td></tr>
                    <tr><td> (d) Science Quiz </td><td> 	VI	 </td><td> 2 </td><td> 	PYM </td><td></td></tr>
                    <tr><td> (e) Science games	 </td><td> VII </td><td> 	2 </td><td> 	PYM </td><td></td></tr>
                    <tr><td> (f) Role Play	 </td><td> VIII </td><td> 	1-Jan </td><td> 	ASN </td><td></td></tr>
                    <tr><td> (g) Demonstrate the concept </td><td> 	IX </td><td> 	2	 </td><td> SHB </td><td></td></tr>
                    <tr><td> (h) Discover Science </td><td> 	X </td><td> 	2	 </td><td> SHB </td><td></td></tr>
                    <tr><td> (i) Creative Solution </td><td> 	XI-XII </td><td> 	2	 </td><td> ASN </td><td></td></tr>
                    <tr><td> (j) Chemistry Demo </td><td> 	XI-XII	 </td><td> 2	 </td><td> SHB </td><td></td></tr>
                    <tr><td> (k) Innovative Biology </td><td> 	XI-XII </td><td> 	2 </td><td> 	PYM  </td><td></td></tr>


                     <tr> <td rowspan="17"> 3 </td> <td rowspan="17"> Abhivyakti 2025 </td> <td rowspan="17"> Gyan Mandir public School, Naraina</td> <td rowspan="17"> 7-9 May 25 </td> <td rowspan="17"> 17th April 2025 </td>  
                     <td> (a) Culinary Alchemy </td> <td> 	VI-VIII </td> <td> 	2 </td> <td> 	SHB </td><td></td></tr>
                     <tr><td> (b) Pyphysix Challenge </td> <td> 	IX-X </td> <td> 	2	 </td> <td> ASN </td> <td></td></tr>
                     <tr><td> (c) Scibiz Innovators </td> <td> 	XI-XII </td> <td> 	1	 </td> <td> PYM & RSA </td> <td></td></tr>
                     <tr><td> (d) Canva Strokes	 </td> <td> VI-VIII </td> <td> 	2 </td> <td> 	MVJ </td> <td></td></tr>
                     <tr><td> (e) Director's Cut	 </td> <td> XI-XII	 </td> <td> 2	 </td> <td> NEG </td> <td></td></tr>
                     <tr><td> (f) Mobilityx	 </td> <td> VI-VIII </td> <td> 	2	 </td> <td> ASN </td> <td></td></tr>
                     <tr><td> (g) Roborace </td> <td> 	VI-VIII </td> <td> 	2-3 </td> <td> 	ASN </td> <td></td></tr>
                     <tr><td> (h) Healtech Challenge	 </td> <td> IX-XII	 </td> <td> 2	 </td> <td> PYM & NEG </td> <td></td></tr>
                     <tr><td> (i) Dot-a-pot </td> <td> 	VI-VII </td> <td> 	2 </td> <td> 	MVJ </td> <td></td></tr>
                     <tr><td> (j) Echoes of grandeur </td> <td> 	IX-X </td> <td> 	2 </td> <td> 	SHD </td> <td></td></tr>
                     <tr><td> (k) Warli glow	 </td> <td> IX-X	 </td> <td> 1	 </td> <td> MVJ </td> <td></td></tr>
                     <tr><td> (l) Candid Chats </td> <td> 	XI-XII </td> <td> 	2	 </td> <td> TSC </td> <td></td></tr>
                     <tr><td> (m) Resin Art </td> <td> 	XI-XII </td> <td> 	2	 </td> <td> MVJ </td> <td></td></tr>
                     <tr><td> (n) Voice of Cricket	 </td> <td> XI-XII </td> <td> 	2 </td> <td> 	MPP </td> <td></td></tr>
                     <tr><td> (o) Maths-o-groove </td> <td> 	IX-X </td> <td> 	2 </td> <td> 	VNS </td> <td></td></tr>
                     <tr><td> (p) Mathsymphonia </td> <td> 	XI-XII </td> <td> 	1 </td> <td> 	VNS </td> <td></td></tr>
                     <tr><td> (q) Baskethon	 </td> <td> VI-VIII </td> <td> 	2 </td> <td> 	MPP </td> <td></td></tr>
                    <tr> <td> 4 </td> <td> Transcendence 3.0 2025 </td> <td>Air Force Bal Bharti School, Lodi Road </td> <td>8-9 May 25 </td> <td>   29th April 2025</td> <td> MUN </td> <td> VIII-XII </td> <td> 7 </td> <td> SBR </td> <td> <p> </p> </td> </tr> 
                     
                    </tbody>
                    </table>
                    </div>
                </div>
            </div>
        </div>
     </>
  )
}

export default InterSchoolCorner